<template>
<div class="page_home_news col-lg-8 mb-8">
    <!-- carousel -->
    <v-carousel hide-delimiters height="auto">
        <v-carousel-item
        v-for="(img,i) in carousel"
        :key="i"
        :src="img.src"
        ></v-carousel-item>
    </v-carousel>
    <!-- news -->
    <h2 class="mt-4 mb-3">最新消息
        <small>News</small>
    </h2>
    <!-- pagination -->
    <v-pagination v-show="news[0]" v-model="page" :length="news.length"></v-pagination>

    <table class="table table-responsive">
        <tbody>
            <tr
                v-for="item in news[page-1]"
                :key="item.title"
            >
                <th scope="row">
                    <h4>
                        <span v-if="item.announcer == 'ceec'"   class="badge badge-primary"  >大考中心</span>
                        <span v-if="item.announcer == 'cac'"    class="badge badge-info"     >甄委會</span>
                        <span v-if="item.announcer == 'uac'"    class="badge badge-warning"  >考分會</span>
                        <span v-if="item.announcer == 'jbcrc'"  class="badge badge-success"  >招聯會</span>
                        <span v-if="item.announcer == 'cape'"   class="badge badge-secondary">術聯會</span>
                    </h4>
                </th>
                <td>
                    <v-chip v-for="(type, index) in item.type" :key="index" small text-color="white" color="primary">{{ type }}</v-chip>
                    <br v-if="item.type[0]">
                    <a
                    v-for="t in item.titles"
                    :key="t.title"
                    :href="t.link == '' ? null : t.link" target="_blank"
                    >
                        {{ t.title }}
                    </a>
                </td>
                <td class="time">{{ item.date.slice(0,10) }}</td>
            </tr>
        </tbody>
    </table>
        
    <hr>
    <div class="card mb-4">
        <div class="card-body reminder">
            <h2 class="card-title">重要提醒</h2>
            <p class="card-text">
                <NoteItem/>
            </p>
        </div>
    </div>
</div>
</template>

<script>
import NoteItem from './noteItem.vue';

export default {
	components: {
		NoteItem
	},

    data() {
        return {
            news: [],
            page: 1,
            pageSize: 15,
            carousel: [
                { src: require('page/_home/img/carousel/1.png') },
                { src: require('page/_home/img/carousel/2.png') },
            ],
        }
    },
    methods: {
        chunkNews (news, size) {
            let results = []
            while (news.length) results.push(news.splice(0, size))
            return results
        },
    },
    async beforeCreate () {
        const news = await ___.api.news.getPublished()
        this.news = this.chunkNews(news, this.pageSize)
    }
}
</script>

<style lang="scss">
    .date-title {
        width: 110px;
    }
</style>
